import { AnyAction } from 'redux';
import { ofType } from 'redux-observable';
import { Observable, concatMap, filter, of } from 'rxjs';
import { AppEpic } from 'src/store';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { isEqual, isNil, nth } from 'lodash';
import { extractNavPath } from 'src/pages/NavigationShell/navigationUtils';
import { isSome } from 'fp-ts/es6/Option';
import { removeLastCrumb, resetAllCrumbs } from './Bread.slice';
import { setPossibleBreadcrumbs } from 'src/components/Subheader/Subheader.slice';

export const updateBreadcrumbAfterManualNavigationEpic: AppEpic = (action$, state$): Observable<AnyAction> => {
  return action$.pipe(
    ofType(setActivePage.type, setActiveSubPage.type),
    filter(() => !isNil(state$.value.breadcrumbs.activeBreadcrumb)),
    filter(() => {
      const bread = state$.value.breadcrumbs;
      const activeCrumbPath = bread.crumbPaths[bread.activeBreadcrumb!]; // checked for nil in `filter` above
      const currentNavPath = extractNavPath(window.location, 'hash');
      const secondToLastCrumbPath = nth(activeCrumbPath, -2);

      if (!isSome(currentNavPath)) return false;

      // never trust a string
      try {
        // the window.location.hash includes the ? because we are bad people
        // clear it out here and pray that the string manipulation doesn't break
        const cleanNavPath = currentNavPath.value.map((p) => (p?.includes('?') ? p.split('?')[0] : p));
        if (cleanNavPath && secondToLastCrumbPath && isEqual(cleanNavPath, secondToLastCrumbPath.path)) {
          return true;
        }
      } catch (_err) {
        return false;
      }

      return false;
    }),
    concatMap(() => of(removeLastCrumb())),
  );
};

export const clearBreadcrumbsWhenNavigatingToNonBreadcrumbView: AppEpic = (action$, state$): Observable<AnyAction> => {
  return action$.pipe(
    ofType(setPossibleBreadcrumbs.type),
    filter(() => !isNil(state$.value.breadcrumbs.activeBreadcrumb)),
    filter(() => isNil(state$.value.subheader.possibleBreadcrumbs)),
    concatMap(() => of(resetAllCrumbs())),
  );
};
